import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Eye, LogOut, ArrowRight, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ObserverDashboard() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/observer/dashboard`, { withCredentials: true })
      .then(r => setData(r.data))
      .catch(e => toast.error(e.response?.data?.detail || 'Failed'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin h-8 w-8 text-brandpurple" /></div>;
  const obs = data?.observer || {};
  const tenders = data?.tenders || [];

  return (
    <div className="min-h-screen bg-slate-50" data-testid="observer-dashboard-page">
      <header className="bg-navy text-white py-4 px-6 flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2"><Eye className="w-5 h-5 text-gold" /><span className="text-lg font-black">Society Observer · View Only</span></div>
          <div className="text-xs opacity-80 mt-0.5">{obs.username}</div>
        </div>
        <button onClick={() => { logout(); navigate('/login'); }} className="text-xs px-3 py-1.5 rounded border border-white/30 flex items-center gap-1" data-testid="observer-logout-btn"><LogOut className="w-3 h-3" /> Logout</button>
      </header>
      <main className="max-w-6xl mx-auto py-8 px-4">
        <div className="mb-4 p-3 bg-brandpurple/5 border border-brandpurple/20 rounded text-xs text-brandpurple">You have view-only access. You cannot approve, reject, comment, or modify anything.</div>
        {tenders.length === 0 ? (
          <div className="bg-white border border-slate-100 rounded-2xl p-8 text-center text-sm text-slate-500">No procurements have been shared with you.</div>
        ) : (
          <div className="space-y-2">
            {tenders.map(t => (
              <div key={t.id} className="bg-white border border-slate-100 rounded-2xl p-5 hover:shadow-md cursor-pointer flex items-start justify-between" onClick={() => navigate(`/observer/tender/${t.id}`)} data-testid={`observer-tender-${t.id}`}>
                <div>
                  <div className="text-xs uppercase text-slate-500 font-bold">{t.work_category} · {t.location || '—'}</div>
                  <div className="font-bold text-navy mt-0.5">{t.title}</div>
                  <div className="text-xs text-slate-600 mt-1">Status: <strong className="text-brandpurple">{t.status}</strong> · Budget: {t.estimated_value ? `₹${Number(t.estimated_value).toLocaleString('en-IN')}` : 'N/A'}</div>
                </div>
                <ArrowRight className="w-5 h-5 text-slate-400" />
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
